import { FC } from 'react'

import { BuilderComponentSettingValue } from '@makyoapp/makyo-common'
import { SelectDropdown } from '@makyoapp/makyo-ui'

interface LayoutColumnSelectProps {
  id: string
  value: any
  onChange: (
    cb?:
      | BuilderComponentSettingValue
      | BuilderComponentSettingValue[]
      | (() => BuilderComponentSettingValue | BuilderComponentSettingValue[])
  ) => Promise<any>
}

type ColumnWidth = number

export type ColumnLayout = ColumnWidth[]

interface LayoutPreviewProps {
  layout: ColumnLayout
}

const LayoutPreview: React.FC<LayoutPreviewProps> = ({ layout }) => {
  return (
    <div className='flex items-center gap-1 w-full'>
      {layout?.map((width, idx) => (
        <div
          key={idx}
          className='h-[18px] text-m-ss text-zinc-300  bg-gray-600 dark:text-zinc-600 dark:bg-gray-300 rounded-sm text-center content-center'
          style={{ width: `${(width / 12) * 100}%` }}
        >
          {`${((width / 12) * 100).toFixed(0)}%`}
        </div>
      ))}
    </div>
  )
}

export const COLUMN_LAYOUTS: ColumnLayout[] = [
  [12],
  [6, 6],
  [7.2, 4.8],
  [4.8, 7.2],
  [8.4, 3.6],
  [3.6, 8.4],
  [8, 4],
  [4, 8],
  [3, 9],
  [9, 3],
  [4, 4, 4],
  [3, 3, 3, 3],
]

export const LayoutColumnSelect: FC<LayoutColumnSelectProps> = ({ id, onChange, value }) => {
  return (
    <SelectDropdown
      onChange={onChange}
      id={id}
      options={COLUMN_LAYOUTS}
      value={value}
      renderOption={(layout: ColumnLayout) => <LayoutPreview layout={layout} />}
    />
  )
}
